import src from "IMAGE";
export default { src, width: 335, height: 88, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/AFsKF1VKCBNFPgcPOkMHET1EBxE/NgYOMUkIEkMuBQsqADUFDTIgAwgdRAcRP1gJFlJTCRVNTQgTRlIJFEs1Bg0wPLoJideBq1sAAAAASUVORK5CYII="};
